import { Main } from 'wikr-core-analytics';
import { StartHOC } from 'testania';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import React, { useEffect } from 'react';

import config from 'config';

import { setGender } from 'redux/Onboadring/actions';

import withReadyTranslation from 'HOC/withReadyTranslation';

import { usePreloadNextPage } from 'hooks';

import GenderContainer from 'containers/StartContainers/GenderContainer';

import { ICommonPageProps } from 'types/pages/startPages/commonTypes';
import { IGender, IGendersData } from 'types/commonInterfaces';

import { CONFIG_FEMALE, CONFIG_MALE } from './config';

function IndexPage({ toNextPage, getNextPage, history }: ICommonPageProps & RouteComponentProps) {
    const dispatch = useDispatch();

    usePreloadNextPage({ getNextPage });

    useEffect(() => {
        Main.customData('index__screen__load');
    }, []);

    const handleToNextPage = (gender: IGender) => {
        dispatch(setGender(gender));

        Main.customData('index_click', { event_label: gender });

        toNextPage();
    };

    const GENDER_DATA: IGendersData = {
        title: 'startPage.index.title',
        genders: [
            {
                sex: 'male',
                buttonTitle: 'Male',
                images: CONFIG_MALE,
                dataLocator: 'malePulseGenderBtn',
            },
            {
                sex: 'female',
                buttonTitle: 'Female',
                images: CONFIG_FEMALE,
                dataLocator: 'femalePulseGenderBtn',
            },
        ],
    };

    // TODO: refactor container and it's sub-components
    return (
        <GenderContainer
            analytic={Main}
            indexPage
            loginLink={config.USER_CABINET_URL}
            pulseNumber="PulseOne"
            genderData={GENDER_DATA}
            history={history}
            toNextPage={handleToNextPage}
        />
    );
}

export default compose<typeof IndexPage>(StartHOC, withReadyTranslation)(IndexPage);
